import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './Red_Outline_Btn.css'

const Red_Outline_Btn = (props) => {
    return (
        <button className="Red_Outline_Btn" onClick={props?.onClick} type='button'>
            {props?.leftIcon && (
                <div className='icon_holder'>
                    <FontAwesomeIcon icon={props?.leftIcon} className='left_icon' />
                </div>
            )}

            <p className='btn_text'>{props?.btn_name}</p>

            {props?.rightIcon && (
                <div className='icon_holder'>
                    <FontAwesomeIcon icon={props?.rightIcon} className='right_icon' />
                </div>
            )}
        </button>
    )
}

export default Red_Outline_Btn
